/**
 * Retro Cult — lightweight storefront interactions
 * Scroll reveal, quiz filters, countdown timer
 */
(function () {
  'use strict';

  function initScrollReveal() {
    const elements = document.querySelectorAll('.rc-reveal');
    if (!elements.length) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      elements.forEach((el) => el.classList.add('is-visible'));
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.1 }
    );

    elements.forEach((el) => observer.observe(el));
  }

  function initQuiz() {
    document.querySelectorAll('[data-rc-quiz]').forEach((section) => {
      const filters = section.querySelectorAll('[data-rc-quiz-filter]');
      const result = section.querySelector('[data-rc-quiz-result]');
      const baseUrl = section.dataset.collectionUrl || '/collections/all';
      const active = new Set();

      filters.forEach((btn) => {
        btn.addEventListener('click', () => {
          const value = btn.dataset.rcQuizFilter;
          if (active.has(value)) {
            active.delete(value);
            btn.classList.remove('is-active');
          } else {
            active.add(value);
            btn.classList.add('is-active');
          }

          if (!result) return;

          if (active.size === 0) {
            result.innerHTML = section.dataset.emptyText || 'Pick a vibe to explore jerseys.';
            return;
          }

          const tags = Array.from(active).join('+');
          result.innerHTML =
            'Showing pieces tagged: <strong>' +
            Array.from(active).join(', ') +
            '</strong>. <a href="' +
            baseUrl +
            '?filter.p.tag=' +
            encodeURIComponent(tags) +
            '">View matches →</a>';
        });
      });
    });
  }

  function initCountdown() {
    document.querySelectorAll('[data-rc-countdown]').forEach((el) => {
      const target = el.dataset.rcCountdown;
      if (!target) return;

      const end = new Date(target).getTime();
      const daysEl = el.querySelector('[data-unit="days"]');
      const hoursEl = el.querySelector('[data-unit="hours"]');
      const minsEl = el.querySelector('[data-unit="minutes"]');
      const secsEl = el.querySelector('[data-unit="seconds"]');

      function tick() {
        const now = Date.now();
        let diff = Math.max(0, end - now);
        const days = Math.floor(diff / 86400000);
        diff -= days * 86400000;
        const hours = Math.floor(diff / 3600000);
        diff -= hours * 3600000;
        const minutes = Math.floor(diff / 60000);
        diff -= minutes * 60000;
        const seconds = Math.floor(diff / 1000);

        if (daysEl) daysEl.textContent = String(days).padStart(2, '0');
        if (hoursEl) hoursEl.textContent = String(hours).padStart(2, '0');
        if (minsEl) minsEl.textContent = String(minutes).padStart(2, '0');
        if (secsEl) secsEl.textContent = String(seconds).padStart(2, '0');
      }

      tick();
      setInterval(tick, 1000);
    });
  }

  function init() {
    initScrollReveal();
    initQuiz();
    initCountdown();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
